import { type Card, RANK_LABEL, SUIT_NAME, SUIT_SYMBOL, isRed, longName, rankOf, suitOf } from '@shared/cards';

type Size = 'hand' | 'table' | 'small';

export function CardFace(props: {
  card?: Card;
  faceDown?: boolean;
  size?: Size;
  selected?: boolean;
  pending?: boolean;
  disabled?: boolean;
  highlight?: boolean;
  dim?: boolean;
  onClick?: () => void;
  label?: string;
}) {
  const { card, faceDown, size = 'hand', selected, pending, disabled, highlight, dim, onClick } = props;
  const cls = ['card'];
  if (size === 'table') cls.push('table-size');
  if (size === 'small') cls.push('small');
  if (selected) cls.push('selected');
  if (pending) cls.push('pending');
  if (disabled) cls.push('disabled');
  if (highlight) cls.push('highlight');
  if (dim) cls.push('dim');
  if (faceDown || card === undefined) {
    cls.push('back');
    return <div className={cls.join(' ')} aria-label={props.label ?? 'face-down card'} role="img" />;
  }
  if (isRed(card)) cls.push('red');
  cls.push(SUIT_NAME[suitOf(card)]);
  const inner = (
    <>
      <span className="idx" aria-hidden="true">
        <span className="r">{RANK_LABEL[rankOf(card)]}</span>
        <span className="s">{SUIT_SYMBOL[suitOf(card)]}</span>
      </span>
      <span className="ctr" aria-hidden="true">
        {SUIT_SYMBOL[suitOf(card)]}
      </span>
    </>
  );
  if (onClick) {
    return (
      <button type="button" className={cls.join(' ')} onClick={onClick} disabled={disabled} aria-pressed={selected || undefined} aria-label={props.label ?? longName(card)}>
        {inner}
      </button>
    );
  }
  return (
    <div className={cls.join(' ')} role="img" aria-label={props.label ?? longName(card)}>
      {inner}
    </div>
  );
}
